<script setup lang="ts">
  import { STAGE_VERSION_NAMES } from '#ourahub-intra/constants'

  import type { AppEnvironment } from '#web-oura-tools/types/auth'

  defineProps<{
    modelValue: boolean
    serviceName: string
    stage: AppEnvironment
    loading?: boolean
  }>()

  const emits = defineEmits<{
    'update:modelValue': [value: boolean]
    'confirm': []
  }>()
</script>

<template lang="html">
  <v-dialog max-width="600" :model-value="modelValue" @update:model-value="emits('update:modelValue', $event)">
    <v-card>
      <v-card-title>Make the {{ STAGE_VERSION_NAMES[stage] }} version private</v-card-title>

      <v-card-text>
        <p>
          You are about to make the
          <b>{{ STAGE_VERSION_NAMES[stage] }}</b>
          version of
          <b>{{ serviceName }}</b>
          private. Only maintainers will be able to access it.
        </p>

        <p>You can make it public again at any time without a new review.</p>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <o-btn-text text="Cancel" @click="emits('update:modelValue', false)" />
        <o-btn-error text="Make private" prepend-icon="mdi-publish-off" :loading="loading" @click="emits('confirm')" />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
